import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import LoaderMain from 'components/shared/LoaderMain';

const SkeletonTransferResult: FC = () => {
    return (
  <>
      <div className="transfer-results">
        <div className="transfer-results-data">
          {[...Array(4)].map((_, index) => (
            <div className="default-shadow transfer-card" key={index}>
              <div className="transfer-card-img">
                <Skeleton width={120} height={60} style={{ marginTop: 35, marginInlineStart: 9 }} />
              </div>
              <div className="transfer-card-data">
                <div className="card-title">
                  <Skeleton width={200} height={24} />
                </div>
                <div className="card-data">
                  <div className="card-data-item">
                    <Skeleton width={24} height={24} className="mb-10" />
                    <Skeleton width={180} height={29} />
                  </div>
                  <div className="card-data-item">
                    <Skeleton width={24} height={24} className="mb-10" />
                    <Skeleton width={180} height={29} />
                  </div>
                  <div className="card-data-item">
                    <Skeleton width={24} height={24} className="mb-10" />
                    <Skeleton width={180} height={29} />
                  </div>
                </div>
              </div>
              <div className="transfer-card-info text-center">
                <div className="price-total">
                  <div className="text-sm mb-5">
                    <Skeleton width={140} height={15} />
                  </div>
                  <div className="text-bold mr-5 mb-10">
                    <Skeleton width={120} height={16} />
                  </div>
                </div>
                <div className="price-total">
                  <div className="text-sm mb-5">
                    <Skeleton width={140} height={15} />
                  </div>
                  <div className="text-bold mr-5 mb-10">
                    <Skeleton width={120} height={16} />
                  </div>
                </div>
                <Skeleton width={24} height={24} />
              </div>
            </div>
          ))}
        </div>
        <div className="transfer-results-info">
          <div className="default-shadow transfer-sum">
            <div className="title-underline text-md">
              <Skeleton height={24} width={120} />
            </div>
            <div className="h200px w100p">
              <Skeleton height={'100%'} />
            </div>
          </div>
        </div>
      </div>
      <LoaderMain systemProducts="Transfers" />
  </>
  );
};

export default SkeletonTransferResult;
